import styled from 'styled-components';
import { SettingsField } from 'pages/Settings/Settings.styles';

export const EntityInputField = styled(SettingsField)<{ large?: boolean }>`
  margin-bottom: 16px;
  max-width: ${({ large }) => (large ? '368px' : '248px')};
`;
